export const baseButtonSx = {
	textTransform: "none",
	fontWeight: 600,
	fontSize: 13,
	letterSpacing: "0.01em",
	borderRadius: 999,
	px: 2,
	py: 0.75,
	minHeight: 36,
	gap: 0.5
};

export const destructiveButtonSx = {
	...baseButtonSx,
	background: "#FFFFFF",
	color: "#B42318",
	border: "1px solid rgba(232, 80, 91, 0.45)",
	"&:hover": {
		background: "rgba(232, 80, 91, 0.06)",
		border: "1px solid rgba(232, 80, 91, 0.85)"
	},
	"&.Mui-disabled": {
		background: "#FFFFFF",
		color: "rgba(13, 31, 48, 0.30)",
		border: "1px solid rgba(13, 31, 48, 0.10)"
	}
};

export const gradientPrimaryButtonSx = {
	...baseButtonSx,
	background: "var(--coapp-gradient-primary, linear-gradient(135deg, #02D5AB 0%, #0A7FA8 100%))",
	color: "#FFFFFF",
	border: "none",
	"&:hover": {
		background: "var(--coapp-gradient-primary, linear-gradient(135deg, #02D5AB 0%, #0A7FA8 100%))",
		boxShadow: "0 0 0 4px rgba(2, 213, 171, 0.18)",
		filter: "brightness(1.05)"
	},
	"&.Mui-disabled": {
		background: "rgba(13, 31, 48, 0.10)",
		color: "rgba(13, 31, 48, 0.40)"
	},
	"& .MuiButton-startIcon path": { fill: "#FFFFFF !important" },
	"&.Mui-disabled .MuiButton-startIcon path": { fill: "rgba(13, 31, 48, 0.40) !important" }
};

export const clearButtonSx = {
	...baseButtonSx,
	background: "#FFFFFF",
	color: "rgba(13, 31, 48, 0.60)",
	border: "1px solid rgba(13, 31, 48, 0.14)",
	"&:hover": {
		background: "rgba(13, 31, 48, 0.04)",
		border: "1px solid rgba(13, 31, 48, 0.28)"
	},
	"&.Mui-disabled": {
		background: "#FFFFFF",
		color: "rgba(13, 31, 48, 0.30)",
		border: "1px solid rgba(13, 31, 48, 0.10)"
	}
};

export const destructiveIconSx = {
	fontSize: 16,
	"& path": { fill: "currentColor" }
};

export const selectionRowContainerSx = {
	display: "flex",
	alignItems: "center",
	justifyContent: "space-between",
	gap: 2,
	background: "#FFFFFF",
	borderTop: "1px solid rgba(13, 31, 48, 0.08)",
	boxShadow: "none",
	px: 3,
	py: 1.5
};
